import { blogList } from "../data.js";
import { localizeField } from "../i18n.js";
import PostRow from "./PostRow.jsx";

export default function BlogsPage({ t, copy, language }) {
  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 400, marginBottom: 18 }}>{copy.blogPosts}</h2>
      <div>
        {blogList.map((post, i) => (
          <PostRow
            root={"blog"}
            link={true}
            key={post.id}
            path={post.id}
            label={post.date}
            title={localizeField(post, "title", language)}
            isFirst={i === 0}
            t={t}
            copy={copy}
            language={language}
          />
        ))}
      </div>
    </div>
  );
}
